export default __webpack_public_path__ + "static/media/person-gold.0a865bda.svg";